// components
import PageHeader from "@layout/PageHeader";
import AppGrid from "@layout/AppGrid";
import WidgetGroup from "@components/WidgetGroup";
import FileCard from "@components/FileCard";

const widgets = {
  doc1: (
    <WidgetGroup>
      <FileCard
        name="Régimen Especial"
        detail="R.E"
        a="static/regimen_especial.pdf"
      />
      <FileCard
        name="Certificado de Pagos"
        detail="Certificado de pagos a cargos directivos"
        a="static/pagos.pdf"
      />
    </WidgetGroup>
  ),
  doc2: (
    <WidgetGroup>
      <FileCard
        name="Presupuestos"
        detail="Presuspuestos"
        a="static/presupuestos.pdf"
      />
    </WidgetGroup>
  ),

  doc4: (
    <WidgetGroup>
      <FileCard
        name="Certificado de Permanencia ESAL"
        detail="Certificado de Permanencia ESAL"
        a="static/esal.pdf"
      />
      <FileCard
        name="Dictamen revisoria fiscal"
        detail="D.R.F"
        a="static/distamen_revisoria_fiscal.pdf"
      />
    </WidgetGroup>
  ),
  doc5: (
    <WidgetGroup>

      <FileCard
        name="Firma Electronica"
        detail="Firma Electronica"
        a="static/firma_electronica.pdf"
      />
      <FileCard
        name="Informe de Gestión"
        detail="Informe de Gestión"
        a="static/gestion.pdf"
      />
    </WidgetGroup>
  ),
  doc6: (
    <WidgetGroup>
      <FileCard
        name="Estados Financieros 2025"
        detail="Estados Financieros 2025"
        a="static/estados_financieros.pdf"
      />
      <FileCard
        name="Antecedentes"
        detail="Certificado de Antecedentes"
        a="static/antecedentes.pdf"
      />
    </WidgetGroup>
  ),
};

const Dian = () => {
  return (
    <>
      <PageHeader title="Información DIAN" />
      <AppGrid id="dian" widgets={widgets} />
    </>
  );
};

export default Dian;
